const config = {
  paginationLimit: 20,
  photoUploadUrl: '/api/photos',
  prefixUrlApi: '/api'
}

export default config
